"use strict";

import "./UserNotifications.css";

import React from "react";
import ReactDOM from "react-dom";

import lang from "vwa/lang";
import Tabs from "vwa/components/Tabs";
import Pager from "vwa/components/Pager";

import POICrossingNotifications from "./../POICrossingNotifications";
import CriticalValueNotifications from "./../CriticalValueNotifications";

import eventDescriptorStore from "./../../store/eventDescriptors";

export default class UserNotifications extends React.Component {

	constructor(props){
		super(props);
		this.initState();
	}
	
	initState(){
		this.state = {
			page: "poiCrossingNotifications"
		};
	}
	
	getPOINotificationSets(){
		const session = sessionStore.get();
		
		if(!session){
			return null;
		}
		
		const notificationSets = session.user.services.filter(service => service.type == "NotificationSet");
		
		const eventDescriptors = eventDescriptorStore.getAll();
		if(!eventDescriptors){
			return null;
		}
		
		const poiNotificationSets = eventDescriptors.filter(
			eventDescriptor => eventDescriptor.type == "POI"
		).map(
			eventDescriptor => notificationSets.find(e => e.descriptor == eventDescriptor._id)
		);
	}
	
	getCriticalValueNotificationSets(){
		const session = sessionStore.get();
		
		if(!session){
			return null;
		}
		
		const notificationSets = session.user.services.filter(service => service.type == "NotificationSet");
		
		const eventDescriptors = eventDescriptorStore.getAll();
		if(!eventDescriptors){
			return null;
		}
		
		const criticalValueNotificationSets = eventDescriptors.filter(
			eventDescriptor => eventDescriptor.type == "CriticalValue"
		).map(
			eventDescriptor => notificationSets.find(e => e.descriptor == eventDescriptor._id)
		);
	}
	
	render(){		
		return(
			<div className="UserNotifications">
				<header className="Shadowed">
					<Tabs
						selected={this.state.page}
						onChange={id => this.setState({page: id})}
					>
						<li id="poiCrossingNotifications">{lang.POI_CROSSING_NOTIFICATIONS}</li>
						<li id="criticalValueNotifications">{lang.CRITICAL_VALUE_NOTIFICATIONS}</li>
					</Tabs>
				</header>
				<div className="Content">
					<Pager active={this.state.page}>
						<div id="poiCrossingNotifications">
							<POICrossingNotifications />
						</div>
						<div id="criticalValueNotifications">
							<CriticalValueNotifications />
						</div>
					</Pager>
				</div>
			</div>
		);
	}

}

UserNotifications.propTypes = {

};

UserNotifications.defaultProps = {

};


// WEBPACK FOOTER //
// ./src/view/UserNotifications/UserNotifications.jsx